import {
  Component,
  OnInit,
  Input,
  ViewChild,
  OnDestroy,
  Output,
  EventEmitter,
  AfterContentInit,
  AfterViewInit,
  AfterContentChecked
} from '@angular/core'
import { FormGroup } from '@angular/forms'
import { ActivatedRoute } from '@angular/router'
import { CpmService } from '../../service/cpm.service'
import { StoreService } from '../../service/store.service'
import { Subscription } from 'rxjs/Subscription'
import { DataTableDirective } from 'angular-datatables'
import { Subject } from 'rxjs/Subject'
import { BsModalService } from 'ngx-bootstrap/modal'
import { AuthorizeService } from '../../service/authorize.service'

@Component({
  selector: 'app-case-table',
  templateUrl: './case-table.component.html',
  styleUrls: ['./case-table.component.scss']
})
export class CaseTableComponent implements OnInit, OnDestroy, AfterViewInit,AfterContentChecked {
  @ViewChild(DataTableDirective) dtElement: DataTableDirective
  @Input() companyProfile: any
  @Input() printPage
  @Output() emitEditCase: EventEmitter<any> = new EventEmitter()

  dtTriggerForcase: Subject<any> = new Subject()
  subscription: Subscription
  subscriptionSearch: Subscription
  form: FormGroup
  caseDataTableOptions: any = {}
  type
  initTableFirstTime = false
  listTable = []
  listHeader
  symbol

  constructor(
    private cpmService: CpmService,
    private authorization: AuthorizeService
  ) {}

  ngOnInit() {
    this.listTable = []
    this.caseDataTableOptions = {
      autoWidth: true,
      paging: false,
      searching: true,
      info: false,
      scrollY: '320px',
      // dom: 'Bfrtip',
      scrollCollapse: true,
      order: [[6, 'desc']],
      language: {
        emptyTable: 'No information found'
      },
      columnDefs: [
        {
          type: 'stringMonthYear',
          targets: 6
        },
        {
          targets: 6,
          orderData: 7
        },
        {
          targets: 7,
          visible: false,
          searchable: false
        }
      ],
      destroy: true
    }
    this.onChangeData()
  }

  ngAfterContentChecked() {
    let x = document.getElementsByClassName('dataTables_scrollBody');
    if (x[0]) {
      if (x[0].scrollHeight > x[0].clientHeight) document.getElementsByClassName('dataTables_scrollHeadInner')[0].classList.add("scrollHeadInner");
      else document.getElementsByClassName('dataTables_scrollHeadInner')[0].classList.add("noScrollHeadInner");
    }
  }

  onChangeData() {
    this.type = 'owner'
    if (this.initTableFirstTime) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy()
      })
    }
    this.listTable = []
    this.symbol = ''
    this.cpmService.getCrmCase(this.symbol, this.type).then(success => {
      const listData = success
      listData.map(obj => {
        const list = {
          symbol: obj.securitySymbol,
          comName: obj.companyNameThai,
          owner: obj.caseOwner,
          meet: obj.meetingObjective,
          caseId: obj.caseId,
          status: obj.caseStatus,
          type: obj.type,
          date: obj.lastUpdateDate,
          id: obj.id
        }
        this.listTable.push(list)
      })
      if (!this.initTableFirstTime) {
        this.dtTriggerForcase.next()
        this.initTableFirstTime = true
      } else {
        this.dtElement.dtInstance.then(() => {
          this.dtTriggerForcase.next()
        })
      }
    })

    this.listHeader = [
      'Symbol',
      // 'Company name',
      'Case owner',
      'Case ID',
      'Case type',
      'Service objective',
      'Case status',
      'Update date',
      'Hidden Update Date'
    ]
  }

  ngOnDestroy() {
    if (this.subscription !== undefined) {
      this.subscription.unsubscribe()
    }
    if (this.subscriptionSearch !== undefined) {
      this.subscriptionSearch.unsubscribe()
    }
  }

  ngAfterViewInit() {
    $('.dataTables_scrollHeadInner').css({ width: '100%' })
    $('.dataTables_scrollHeadInner .table').css({ width: '100%' })
    $('.dataTables_scrollBodyInner').css({ width: '100%' })
    $('.dataTables_scrollBodyInner .table').css({ width: '100%' })
  }
  get isUserHasEditPermission() {
    return (
      this.authorization.hasRole('CRM_CASE_EDIT')
    )
  }

  editCase(caseElement) {
    this.emitEditCase.emit(caseElement)
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/crm/case-table/case-table.component.ts